/* eslint-disable */
import Long from 'long'
import * as _m0 from 'protobufjs/minimal'

export const protobufPackage = 'Reality.Reality.Api'

export interface GachaPartsSet {
  id: number
  colorId: string
}

function createBaseGachaPartsSet(): GachaPartsSet {
  return { id: 0, colorId: '' }
}

export const GachaPartsSet = {
  encode(
    message: GachaPartsSet,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id)
    }
    if (message.colorId !== '') {
      writer.uint32(18).string(message.colorId)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GachaPartsSet {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGachaPartsSet()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.id = longToNumber(reader.int64() as Long)
          break
        case 2:
          message.colorId = reader.string()
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },

  fromJSON(object: any): GachaPartsSet {
    return {
      id: isSet(object.id) ? Number(object.id) : 0,
      colorId: isSet(object.colorId) ? String(object.colorId) : '',
    }
  },

  toJSON(message: GachaPartsSet): unknown {
    const obj: any = {}
    message.id !== undefined && (obj.id = Math.round(message.id))
    message.colorId !== undefined && (obj.colorId = message.colorId)
    return obj
  },

  fromPartial<I extends Exact<DeepPartial<GachaPartsSet>, I>>(
    object: I
  ): GachaPartsSet {
    const message = createBaseGachaPartsSet()
    message.id = object.id ?? 0
    message.colorId = object.colorId ?? ''
    return message
  },
}

declare var self: any | undefined
declare var window: any | undefined
declare var global: any | undefined
var globalThis: any = (() => {
  if (typeof globalThis !== 'undefined') return globalThis
  if (typeof self !== 'undefined') return self
  if (typeof window !== 'undefined') return window
  if (typeof global !== 'undefined') return global
  throw 'Unable to locate global object'
})()

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error('Value is larger than Number.MAX_SAFE_INTEGER')
  }
  return long.toNumber()
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any
  _m0.configure()
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}
